import Vue from 'vue'
import axios from './vue-axios/axios'

export function getSiblingsOfEntity(entity_id, email){
  return Vue.axios.get('/v1/entities/' + entity_id + '/siblings', { params: email ? { email } : null})
}

export function getEntitySiblingsByCode(entity_code){
  return Vue.axios.get('/v1/entities/siblings', { params: { entity_code } })
}

export function getEntityResourceByCode(entity_code){
  return Vue.axios.get('/v1/entities/resources', { params: { entity_code } })
}




// WEBPACK FOOTER //
// ./src/backend/entities.js